{
  "instances": {
    "quartz": {
      "actions": "작업",
      "active_triggers": "활성 트리거",
      "associated_triggers": "연결된 트리거",
      "associated_with_calendar": "달력과 연결됨",
      "basic_information": "기본 정보",
      "calendar": "달력",
      "class": "클래스",
      "configuration": "구성",
      "cron_expression": "Cron 표현식",
      "custom_trigger": "사용자 정의 트리거",
      "days_of_week": "요일",
      "description": "설명",
      "details": "세부 정보",
      "disabled": "비활성화됨",
      "durable": "지속성",
      "enabled": "활성화됨",
      "end_time": "종료 시간",
      "final_fire_time": "최종 실행 시간",
      "friday": "금요일",
      "group": "그룹",
      "infinite": "무한",
      "interval": "간격",
      "job_data": "작업 데이터",
      "job_name": "작업 이름",
      "jobs": "작업",
      "key": "키",
      "label": "Quartz",
      "last_fire": "마지막 실행",
      "last_fire_time": "마지막 실행 시간",
      "monday": "월요일",
      "name": "이름",
      "next_fire": "다음 실행",
      "next_fire_time": "다음 실행 시간",
      "no": "아니오",
      "no_data": "사용 가능한 Quartz 정보가 없습니다.",
      "paused_triggers": "일시 중지된 트리거",
      "preserve_hour_of_day": "시간 유지",
      "priority": "우선순위",
      "recovery": "복구",
      "repeat_count": "반복 횟수",
      "request_recovery": "복구 요청",
      "saturday": "토요일",
      "schedule_configuration": "일정 구성",
      "skip_day_if_hour_does_not_exist": "시간이 없으면 날짜 건너뛰기",
      "start_time": "시작 시간",
      "state": "상태",
      "sunday": "일요일",
      "system_default": "시스템 기본값",
      "thursday": "목요일",
      "time_window": "시간 범위",
      "time_zone": "시간대",
      "times_triggered": "실행된 횟수",
      "timing_information": "타이밍 정보",
      "total": "총계",
      "trigger_data": "트리거 데이터",
      "trigger_failed": "트리거 실패",
      "trigger_failed_message": "작업 트리거 실패: {error}",
      "trigger_failed_notification": "작업 \"{jobName}\" 트리거 실패: {error}",
      "trigger_fire_times": "트리거 실행 시간",
      "trigger_job_now": "지금 작업 실행",
      "trigger_success_message": "작업 \"{jobName}\"이(가) 성공적으로 트리거되었습니다",
      "trigger_success_title": "작업 트리거됨",
      "triggers": "트리거",
      "tuesday": "화요일",
      "type": "유형",
      "value": "값",
      "wednesday": "수요일",
      "yes": "예"
    }
  }
}
